export function getApiEndpoint() {
    return process.env.REACT_APP_API 
        ? process.env.REACT_APP_API
        : window.location.origin;
}